export const MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS = {
  imageUrl: undefined as string | undefined,
  icon: undefined as string | undefined,
  iconSet: 'material-symbols-rounded' as const,
  alt: '',
  disabled: false,
  size: 'small' as const,
  showAction: true,
  actionIcon: 'more_vert',
  actionAriaLabel: 'Más opciones',
  showReplaceOption: true,
  showSetCoverOption: true,
  showDeleteOption: true,
} as const;

export type MunilyImagePreviewIconActionSize = 'xsmall' | 'small' | 'large';
